import { render } from "./H1HeaderEdit.vue?vue&type=template&id=2df0a880"
import script from "./H1HeaderEdit.vue?vue&type=script&lang=js"
export * from "./H1HeaderEdit.vue?vue&type=script&lang=js"

import "./H1HeaderEdit.vue?vue&type=style&index=0&id=2df0a880&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__